/**
 * Puschies Rechtstexte: Aufbereitung wie CallMePuppy (cmp-legal + scripts/format-legal-pages.mjs), aber im Browser,
 * damit die Store-Daten (Richtlinien, Seiteninhalte) unverändert bleiben. Der Wortlaut wird NICHT verändert,
 * nur die Struktur: Strichlinien weg, „1) Abschnitt“ / „A. Abschnitt“ / Überschriften → <h2> (mit Sprungmarke),
 * „5.2 Titel“ / fett gesetzte Einzelzeilen → <h3>, „- Punkt“ → Liste, Adressblöcke zusammen, URLs/E-Mails klickbar,
 * Inhaltsverzeichnis ab 3 Abschnitten. Titelzeile des Anbieters (zwischen Strichlinien) → Untertitel.
 *
 * Einsatz: Container [data-p-legal] mit data-toc-label (t:-Key puschies.legal.toc) enthält den Inhalt
 * in [data-p-legal-body] (Seiten) bzw. .shopify-policy__body .rte (Shopify-Richtlinien).
 * Kein fester sichtbarer Text hier: die Überschrift des Inhaltsverzeichnisses kommt aus dem data-Attribut.
 * Dieselbe convert()-Funktion nutzt scripts/format-legal-dry-run.mjs (Node) für den Vorschlag „Store-Daten umbauen“.
 */
(function (root) {
  'use strict';

  var ENT = { nbsp: ' ', amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", shy: '', zwj: '', zwnj: '' };
  function decode(s) {
    return s.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, function (m, e) {
      if (e[0] === '#') {
        var n = e[1] === 'x' || e[1] === 'X' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
        return n === 160 ? ' ' : String.fromCodePoint(n);
      }
      var k = e.toLowerCase();
      return k in ENT ? ENT[k] : m;
    }).replace(/\u00a0/g, ' ');
  }
  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escAttr(s) {
    return esc(s).replace(/"/g, '&quot;');
  }
  function autolink(text) {
    return esc(text)
      .replace(/(https?:\/\/[^\s<)"]+[^\s<)".,;:])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
      .replace(/(^|[\s(])(www\.[\w-]+(?:\.[\w-]+)+[^\s<).,;:]*)/g, '$1<a href="https://$2" target="_blank" rel="noopener">$2</a>')
      .replace(/([\w.+-]+@[\w-]+\.[\w.-]*\w)/g, function (m, mail, off, all) {
        // nicht innerhalb eines gerade erzeugten Links (href/Linktext) ersetzen
        var before = all.slice(0, off);
        if (before.lastIndexOf('<a ') > before.lastIndexOf('</a>')) return m;
        return '<a href="mailto:' + mail + '">' + mail + '</a>';
      });
  }
  function slug(s) {
    return s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }
  function getAttr(tag, name) {
    var m = tag.match(new RegExp('\\s' + name + '\\s*=\\s*("([^"]*)"|\'([^\']*)\'|([^\\s>]+))', 'i'));
    return m ? decode(m[2] || m[3] || m[4] || '') : '';
  }

  var BLOCK = /^(p|div|header|section|article|blockquote|h[1-6]|ul|ol|li|table|hr)$/;

  /**
   * HTML → Zeilen. Jede Zeile: { html, text, src, strong, link, block } bzw. { blank: true } / { raw: html }.
   * Inline bleiben nur <a>, <strong>, <em> erhalten (über Zeilenumbrüche hinweg korrekt geschlossen/geöffnet).
   */
  function tokenize(html) {
    var parts = html.replace(/<!--[\s\S]*?-->/g, '').split(/(<[^>]+>)/);
    var lines = [];
    var cur = null;
    var inline = []; // offene Inline-Tags: {name, open}
    var src = 'p';
    var block = 0;
    var liDepth = 0;
    var strongDepth = 0;
    var linkDepth = 0;
    var skip = 0; // <script>/<style>
    var tableDepth = 0;
    var tableBuf = '';

    function start() {
      if (!cur) {
        cur = { html: '', text: '', src: liDepth ? 'li' : src, strongChars: 0, linkChars: 0, block: block };
        for (var k = 0; k < inline.length; k++) cur.html += inline[k].open;
      }
    }
    function end() {
      if (!cur) return;
      for (var k = inline.length - 1; k >= 0; k--) cur.html += '</' + inline[k].name + '>';
      var text = cur.text.replace(/\s+/g, ' ').trim();
      var h = cur.html
        .replace(/<(strong|em)>(\s*)<\/\1>/g, '$2')
        .replace(/<a [^>]*>(\s*)<\/a>/g, '$1')
        .replace(/\s+/g, ' ')
        .trim();
      if (text) {
        var visible = cur.text.replace(/\s+/g, '').length;
        lines.push({
          html: h, text: text, src: cur.src, block: cur.block,
          strong: visible > 0 && cur.strongChars >= visible,
          link: visible > 0 && cur.linkChars >= visible
        });
      } else {
        lines.push({ blank: true, block: cur.block });
      }
      cur = null;
    }
    function blank() {
      end();
      var last = lines[lines.length - 1];
      if (!last || !last.blank) lines.push({ blank: true, block: block });
    }

    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p) continue;
      if (tableDepth) {
        tableBuf += p;
        if (/^<table[\s>]/i.test(p)) tableDepth++;
        if (/^<\/table>/i.test(p)) tableDepth--;
        if (!tableDepth) { lines.push({ raw: tableBuf }); tableBuf = ''; }
        continue;
      }
      if (p[0] !== '<') {
        if (skip) continue;
        var t = decode(p);
        if (!cur && !t.trim()) continue;
        start();
        cur.text += t;
        var vis = t.replace(/\s+/g, '').length;
        if (strongDepth) cur.strongChars += vis;
        if (linkDepth) cur.linkChars += vis;
        cur.html += linkDepth ? esc(t) : autolink(t);
        continue;
      }
      var m = p.match(/^<(\/?)([a-z0-9]+)/i);
      if (!m) continue;
      var close = !!m[1];
      var name = m[2].toLowerCase();
      if (name === 'script' || name === 'style') { skip += close ? -1 : 1; continue; }
      if (name === 'table' && !close) { blank(); tableDepth = 1; tableBuf = p; continue; }
      if (name === 'br') {
        if (cur) end();
        else lines.push({ blank: true, block: block });
        continue;
      }
      if (BLOCK.test(name)) {
        if (name === 'li') {
          end();
          liDepth += close ? -1 : 1;
          if (liDepth < 0) liDepth = 0;
          continue;
        }
        if (liDepth) { if (close && cur) end(); continue; } // <p> in <li>
        if (name === 'ul' || name === 'ol') { blank(); block++; continue; }
        blank();
        block++;
        src = !close && /^h[1-6]$/.test(name) ? name : 'p';
        continue;
      }
      if (name === 'strong' || name === 'b' || name === 'em' || name === 'i' || name === 'a') {
        var tag = name === 'b' ? 'strong' : name === 'i' ? 'em' : name;
        if (close) {
          for (var j = inline.length - 1; j >= 0; j--) {
            if (inline[j].name === tag) {
              inline.splice(j, 1);
              if (cur) cur.html += '</' + tag + '>';
              break;
            }
          }
          if (tag === 'strong') strongDepth = Math.max(0, strongDepth - 1);
          if (tag === 'a') linkDepth = Math.max(0, linkDepth - 1);
        } else {
          var open = '<' + tag + '>';
          if (tag === 'a') {
            var href = getAttr(p, 'href');
            if (!/^(https?:|mailto:|tel:|\/|#)/i.test(href)) href = '';
            open = href ? '<a href="' + escAttr(href) + '"' + (/^https?:/i.test(href) && !/puschies\./i.test(href) ? ' target="_blank" rel="noopener"' : '') + '>' : '<a>';
            linkDepth++;
          }
          if (tag === 'strong') strongDepth++;
          inline.push({ name: tag, open: open });
          if (cur) cur.html += open;
        }
        continue;
      }
      // span, meta, font, u … → nur Inhalt übernehmen
    }
    end();
    return lines;
  }

  var isRule = function (l) { return /^[–—\-=]{4,}$/.test(l); };
  var isField = function (l) { return /_{6,}/.test(l); };
  var endsSentence = function (l) { return /[.:;,!?)]$/.test(l) && !/^[A-Z]\.\s/.test(l); };
  var isSection = function (l) { return (/^\d+\)\s+\S/.test(l) || /^[A-Z]\.\s+\S/.test(l)) && l.length < 110 && !/[.;]$/.test(l); };

  /**
   * @param {string} html  Inhalt (Richtlinie/Seite)
   * @param {{title?: string, tocLabel?: string}} opts
   * @returns {{html: string, sections: number}}
   */
  function convert(html, opts) {
    opts = opts || {};
    var raw = tokenize(html);
    // Zeilen je Quell-Block zählen (für „fett gesetzte Einzelzeile“)
    var perBlock = {};
    raw.forEach(function (l) { if (!l.blank && !l.raw) perBlock[l.block] = (perBlock[l.block] || 0) + 1; });
    var lines = [];
    raw.forEach(function (l) {
      if (l.blank && (!lines.length || lines[lines.length - 1].blank)) return; // Mehrfach-Leerzeilen
      lines.push(l);
    });
    var txt = function (k) { var l = lines[k]; return l && !l.blank && !l.raw ? l.text : ''; };
    // Oberste Überschriftenebene im Quelltext (ohne reine Link-Überschriften)
    var minH = 7;
    lines.forEach(function (l) { if (l.src && /^h/.test(l.src) && !l.link) minH = Math.min(minH, +l.src[1]); });

    var out = [];
    var toc = [];
    var usedIds = {};
    var list = null;
    var addr = null;
    var skippingToc = false;
    var lastHeading = false;
    var flushList = function () { if (list) { out.push('<ul>' + list.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>'); list = null; } };
    var flushAddr = function () { if (addr) { out.push('<p>' + addr.join('<br>') + '</p>'); addr = null; } };
    var flush = function () { flushList(); flushAddr(); };
    var inner = function (l) { return l.strong ? l.html.replace(/^<strong>([\s\S]*)<\/strong>$/, '$1') : l.html; };
    var h2 = function (l) {
      var base = slug(l.text) || 'abschnitt-' + (toc.length + 1);
      var id = base;
      var n = 2;
      while (usedIds[id]) id = base + '-' + n++;
      usedIds[id] = true;
      toc.push({ id: id, text: l.text });
      out.push('<h2 id="' + id + '">' + inner(l) + '</h2>');
    };

    var i = 0;
    while (i < lines.length && lines[i].blank) i++;
    var doctitle = '';
    if (isRule(txt(i)) && txt(i + 1) && isRule(txt(i + 2))) {
      doctitle = lines[i + 1].text;
      i += 3;
    }

    for (; i < lines.length; i++) {
      var L = lines[i];
      if (L.raw) { flush(); out.push('<div class="p-legal__table">' + L.raw + '</div>'); lastHeading = false; continue; }
      var l = txt(i);
      var prev = txt(i - 1);
      var next = txt(i + 1);
      if (skippingToc) { if (!l) skippingToc = false; continue; }
      if (!l) { flush(); continue; }
      if (isRule(l)) continue;
      if (/^inhaltsverzeichnis:?$/i.test(l)) { flush(); skippingToc = true; continue; }
      var srcH = /^h[1-6]$/.test(L.src) ? +L.src[1] : 0;

      // Überschrift, die nur ein Link ist (z. B. „Zum Retourenportal“) → hervorgehobener Link
      if ((srcH || (L.strong && perBlock[L.block] === 1)) && L.link && /<a href=/.test(L.html)) {
        flush();
        out.push('<p class="p-legal__cta">' + L.html.replace(/<\/?strong>/g, '') + '</p>');
        lastHeading = false;
        continue;
      }
      var betweenRules = (isRule(prev) || isRule(txt(i - 2))) && (isRule(next) || isRule(txt(i + 2)));
      if (betweenRules || isSection(l) || (srcH && srcH === minH) ||
          (L.strong && perBlock[L.block] === 1 && /^[A-Z]\.\s|^\d+\)\s/.test(l) && l.length < 110)) {
        flush(); h2(L); lastHeading = true; continue;
      }
      var strongLine = L.strong && perBlock[L.block] === 1 && l.length < 90 && !/[.;]$/.test(l);
      var standalone = !prev && l.length < 70 && !/:/.test(l) && !endsSentence(l) && /^[A-ZÄÖÜ]/.test(l) && !next;
      var afterHeading = lastHeading && l.length < 70 && !endsSentence(l) && /^[A-ZÄÖÜ]/.test(l) && next.length > 80;
      if (srcH || strongLine || standalone || afterHeading ||
          (/^\d+\.\d+\s/.test(l) && l.length < 90 && !endsSentence(l))) {
        flush();
        out.push('<h3>' + inner(L) + '</h3>');
        lastHeading = true;
        continue;
      }
      lastHeading = false;
      if (L.src === 'li') { flushAddr(); (list = list || []).push(L.html); continue; }
      if (/^[-•–]\s+\S/.test(l)) { flushAddr(); (list = list || []).push(L.html.replace(/^((?:<[^>]+>)*)[-•–]\s+/, '$1')); continue; }
      flushList();
      if (isField(l)) { flushAddr(); out.push('<p class="p-legal__field">' + L.html + '</p>'); continue; }
      if (l.length < 60 && !endsSentence(l) && (addr || (next && next.length < 60 && !endsSentence(next) && !isRule(next)))) {
        (addr = addr || []).push(L.html);
        continue;
      }
      flushAddr();
      out.push('<p>' + L.html + '</p>');
    }
    flush();

    var tocHtml = '';
    if (toc.length >= 3) {
      var prefixed = toc.every(function (t) { return /^\d+\)\s*|^[A-Z]\.\s*/.test(t.text); });
      var label = opts.tocLabel ? esc(opts.tocLabel) : '';
      tocHtml = '<nav class="p-legal__toc"' + (label ? ' aria-label="' + escAttr(opts.tocLabel) + '"' : '') + '>' +
        (label ? '<p class="p-legal__toc-title">' + label + '</p>' : '') +
        '<ol' + (prefixed ? '' : ' class="p-legal__toc--plain"') + '>' +
        toc.map(function (t) {
          var text = prefixed ? t.text.replace(/^\d+\)\s*|^[A-Z]\.\s*/, '') : t.text;
          return '<li><a href="#' + t.id + '">' + esc(text) + '</a></li>';
        }).join('') + '</ol></nav>';
    }
    var head = '';
    if (doctitle && (!opts.title || doctitle.toLowerCase() !== String(opts.title).trim().toLowerCase())) {
      head = '<p class="p-legal__doctitle">' + esc(doctitle) + '</p>';
    }
    return { html: head + tocHtml + out.join('\n'), sections: toc.length };
  }

  function init() {
    var wraps = document.querySelectorAll('[data-p-legal]:not([data-p-legal-done])');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var body = wrap.querySelector('[data-p-legal-body]') || wrap.querySelector('.shopify-policy__body .rte') ||
        wrap.querySelector('.shopify-policy__body');
      var title = wrap.querySelector('h1');
      if (body) {
        try {
          var res = convert(body.innerHTML, {
            title: title ? title.textContent : '',
            tocLabel: wrap.getAttribute('data-toc-label') || ''
          });
          body.innerHTML = res.html;
          body.classList.add('p-legal__content');
          // Direkt auf eine Sprungmarke verlinkt (z. B. /policies/…#3-widerrufsrecht): nach dem Umbau anspringen
          if (location.hash.length > 1) {
            var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
            if (target) target.scrollIntoView();
          }
        } catch (e) {
          /* Original bleibt stehen */
        }
      }
      wrap.setAttribute('data-p-legal-done', '');
    });
  }

  root.pLegal = { convert: convert, init: init };
  if (typeof document !== 'undefined') {
    // Das Script steht direkt hinter dem Inhalt (nicht deferred) → sofort umbauen, bevor gemalt wird
    init();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  }
})(typeof window !== 'undefined' ? window : globalThis);
